import React from 'react'
import { useSelector } from 'react-redux'
import KeyTagFilter from './KeyTagFilter';
import DataTabs from './DataTabs';

export default function KeyTagDataBox() {
    const tagState = useSelector(state=>state.keyTag);
// console.log(tagState);
    const containerStyles={
        width:'100%',
        border: '1px solid #E0E2E6',
        borderRadius:'12px',
        background:'#FFFFFF',
        boxShadow: '0px 4px 16px 0px #1018280F',
        padding:'24px'
    }
  return (
    <div style={containerStyles}>
        <KeyTagFilter/>
        <DataTabs/>
    </div>
  )
}
